<template>
  <v-container>
    <div
      class="d-sm-flex d-xs-block justify-space-between align-center text-center"
    >
      <h1 class="primary--text">Manage Academic Procedure Payments</h1>
      <v-btn
        color="secondary"
        dark
        class="text-capitalize mt-2"
        elevation="0"
        :to="{ name: 'academicProcedures' }"
      >
        Academic Procedures
      </v-btn>
    </div>
    <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
      <v-card-text class="secondary-font pa-3">
        <v-data-table :headers="headers" :items="payments" class="data-table">
          <template v-slot:[`item.paymentDate`]="{ item }">
            <p
              class="mb-0 d-flex flex-column align-sm-start d-xs-block align-center"
            >
              <span> {{ item.paymentDate }} </span>
              <span> {{ item.amountDone ? `${item.amountDone} €` : "" }} </span>
            </p>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <p
              class="mb-0 d-flex flex-column align-sm-start d-xs-block align-center"
            >
              <span> {{ item.type }} </span>
              <span> {{ getPaymentAmountConcept(item) }} € </span>
            </p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              :color="getColor(item)"
              class="text-capitalize lighten-1"
              dark
            >
              {{ getStatus(item) }}
            </v-chip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <a
              v-bind:class="{
                'text-decoration-underline font-weight-bold':
                  selectedPayment === item,
              }"
              v-if="getStatus(item) == 'Pending'"
              @click="showPaymentOptions(item)"
            >
              Make payment ({{ getPaymentAmount(item) }} €)
            </a>
          </template>
        </v-data-table>

        <div v-if="Object.keys(selectedPayment).length > 0">
          <v-row class="mt-4">
            <v-col cols="12">
              <v-checkbox
                label="I accept the payment conditions"
                color="primary"
                class="lable-primary-color ml-4"
                v-model="acceptCondition"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-card class="mx-auto" outlined>
                <v-card-text class="text-center primary--text">
                  <p>If you wish to pay by bank transfer</p>

                  <v-btn
                    color="secondary"
                    class="text-capitalize mt-3"
                    elevation="0"
                    :disabled="!acceptCondition"
                    @click="payFlywire"
                  >
                    Pay by Flywire
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="mx-auto" outlined>
                <v-card-text class="text-center primary--text">
                  <p>
                    If you pay from the EUR zone and wish to pay with a credit
                    or debit card
                  </p>
                  <form
                    ref="redsysForm"
                    :action="actionUrl"
                    method="post"
                    id="redsysForm"
                    name="redsysForm"
                  >
                    <input
                      type="text"
                      name="Ds_SignatureVersion"
                      v-model="dsSignatureVersion"
                      hidden
                    />
                    <input
                      type="text"
                      name="Ds_MerchantParameters"
                      v-model="dsMerchantParameters"
                      hidden
                    />
                    <input
                      type="text"
                      name="Ds_Signature"
                      v-model="dsSignature"
                      hidden
                    />
                    <input
                      type="text"
                      name="Ds_PaymentId"
                      v-model="paymentId"
                      hidden
                    />
                    <v-btn
                      color="secondary"
                      class="text-capitalize mt-3"
                      elevation="0"
                      :disabled="!acceptCondition"
                      @click.prevent="checkPayment()"
                    >
                      Pay by Credit Card
                    </v-btn>
                  </form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <v-alert
          v-if="paymentStatus"
          dense
          text
          :color="paymentStatus.status === 'success' ? 'green' : 'red'"
          outlined
          class="outlined-alert text-center secondary-font mt-5"
          dismissible
        >
          Payment
          {{
            paymentStatus.status === "success" ? "successful" : "unsuccessful"
          }}
          !
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import academicProceduresService from "@/services/academic-procedures-service";

export default {
  data() {
    return {
      headers: [
        { text: "Deadline", value: "deadline", class: "primary--text" },
        { text: "Paid", value: "paymentDate", class: "primary--text" },
        { text: "Concept", value: "type", class: "primary--text" },
        { text: "Method", value: "method", class: "primary--text" },
        { text: "Status", value: "status", class: "primary--text" },
        { text: "", value: "action", class: "primary--text" },
      ],
      payments: [],
      academicProceduresService,

      selectedPayment: {},
      acceptCondition: false,

      // Red Sys
      paymentData: {
        DS_MERCHANT_AMOUNT: "",
        DS_MERCHANT_CURRENCY: "978",
        DS_MERCHANT_MERCHANTCODE: "346252166",
        DS_MERCHANT_MERCHANTURL: `${process.env.VUE_APP_API_URL}student/academic-procedure-payment/update-redsys-status`,
        DS_MERCHANT_ORDER: "12341234",
        DS_MERCHANT_TERMINAL: process.env.VUE_APP_MERCHANT_TERMINAL,
        DS_MERCHANT_TRANSACTIONTYPE: "0",
        DS_MERCHANT_URLKO: `${process.env.VUE_APP_BASE_URL}payment/response/error`,
        DS_MERCHANT_URLOK: `${process.env.VUE_APP_BASE_URL}payment/response/success`,
        DS_MERCHANT_TITULAR: "",
      },
      dsMerchantParameters: null,
      dsSignature: null,
      dsSignatureVersion: null,
      paymentStatus: null,
      pendingPayments: "Has payments",
      paymentId: null,
      actionUrl: process.env.VUE_APP_REDSYS_URL,
    };
  },
  mounted() {
    this.getAcademicProcedurePayments();
  },
  methods: {
    getAcademicProcedurePayments() {
      academicProceduresService
        .getAcademicProcedurePayments(this.$route.params.uuid)
        .then((response) => {
          this.payments = response.data;
        });
    },
    getStatus(item) {
      return item.paymentDate
        ? item.paymentDone === "Cancelled"
          ? "Cancelled"
          : "Done"
        : "Pending";
    },

    getColor(item) {
      let status = this.getStatus(item);
      if (status == "Pending") return "orange";
      if (status == "Cancelled") return "red";
      else return "green";
    },

    showPaymentOptions(selectedOption) {
      this.selectedPayment = selectedOption;
      this.paymentId = selectedOption.id;
    },

    payFlywire() {
      academicProceduresService
        .getFlyWirePaymentOrder({
          ...this.selectedPayment,
        })
        .then((response) => {
          if (response && response.data) {
            window.location = response.data.payment_url;
          }
        });
    },

    async checkPayment() {
      let encodeData = await this.encodePayment();
      if (encodeData) {
        let paymentData = {
          url: `${
            process.env.VUE_APP_BASE_URL
          }/${this.$route.fullPath.substring(1)}`,
          activeTab: this.activeTab,
        };

        localStorage.setItem("paymentData", JSON.stringify(paymentData));
        this.$refs.redsysForm.submit();
      }
    },

    async encodePayment() {
      try {
        this.priceForRedsys();
        this.paymentData.DS_MERCHANT_ORDER = Math.floor(
          Math.random() * 100000001
        ).toString();

        this.paymentData.DS_MERCHANT_MERCHANTDATA = this.paymentId.toString();

        this.paymentData.DS_MERCHANT_TITULAR = this.contactName;
        this.paymentData.DS_MERCHANT_URLKO = `${process.env.VUE_APP_BASE_URL}/payment/response/error`;
        this.paymentData.DS_MERCHANT_URLOK = `${process.env.VUE_APP_BASE_URL}/payment/response/success`;

        // Lets make a string encoded in Base64 with the object width the data
        let merchant = this.$CryptoJS.enc.Utf8.parse(
          JSON.stringify(this.paymentData)
        );

        this.dsMerchantParameters = merchant.toString(
          this.$CryptoJS.enc.Base64
        );

        // Decode from Base 64 the secret key of the commerce from Redsys
        let key = this.$CryptoJS.enc.Base64.parse(
          process.env.VUE_APP_SHA_256_KEY
        );

        // Encrypt the key diversified with the order number in TripleDes
        let iv = this.$CryptoJS.enc.Hex.parse("0000000000000000");
        let cipher = this.$CryptoJS.TripleDES.encrypt(
          this.paymentData.DS_MERCHANT_ORDER,
          key,
          {
            iv: iv,
            mode: this.$CryptoJS.mode.CBC,
            padding: this.$CryptoJS.pad.ZeroPadding, // Redsys dont like padding
          }
        );

        // Signature HASH width de merchant parameters in Base 64 and the TripleDes
        let signature = this.$CryptoJS.HmacSHA256(
          this.dsMerchantParameters,
          cipher.ciphertext
        );

        this.dsSignature = signature.toString(this.$CryptoJS.enc.Base64);
        this.dsSignatureVersion = "HMAC_SHA256_V1";

        return true;
      } catch (error) {
        return false;
      }
    },

    priceForRedsys() {
      let priceN = parseFloat(this.getPaymentAmount(this.selectedPayment));

      if (Number.isInteger(priceN)) {
        this.paymentData.DS_MERCHANT_AMOUNT = priceN.toString() + "00";
      } else {
        let priceFixed = priceN.toFixed(2).toString();
        let priceString = priceFixed.replace(".", "");
        this.paymentData.DS_MERCHANT_AMOUNT = priceString;
      }
    },

    getPaymentAmountConcept(payment) {
      return payment.earlyBird
        ? payment.paymentDate
          ? this.$moment(payment.paymentDate).isSameOrBefore(
              this.$moment(payment.earlyBird).endOf("day")
            )
            ? payment.amountEarly
            : payment.amount
          : this.$moment().isSameOrBefore(
              this.$moment(payment.earlyBird).endOf("day")
            )
          ? payment.amountEarly
          : payment.amount
        : payment.amount;
    },

    getPaymentAmount(payment) {
      return payment.earlyBird &&
        this.$moment().isSameOrBefore(
          this.$moment(payment.earlyBird).endOf("day")
        )
        ? payment.amountEarly
        : payment.amount;
    },
  },
};
</script>
